module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_0-4a87cc4139342979cb5f5c126dc29ec0.jpg";